module.exports = {
  theme: {
    fontFamily: {
      sans: [
        'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
      ],
    },
    screens: {
      md: '768px', // => @media (min-width: 768px) { ... }
      lg: '1024px', // => @media (min-width: 1024px) { ... }
      xl: '1280px', // => @media (min-width: 1280px) { ... }
    },
    fontSize: {
      20: '20px',
      15: '15px',
      14: '14px',
      13: '13px',
      12: '12px',
      10: '10px',
    },
    fontWeight: {
      500: '500',
      400: '400',
    },
    letterSpacing: {
      0.1: '0.1px',
      0.12: '0.12px',
      0.16: '0.16px',
      0.23: '0.23px',
      0.32: '0.32px',
      1.5: '1.5px',
    },
    lineHeight: {
      24: '24px',
      22: '22px',
      19: '19px',
      14: '14px',
    },
    colors: {
      brand: {
        primary: process.env.REACT_APP_ENV === 'rigips' ? '#0368C5' : '#999900',
        dark: process.env.REACT_APP_ENV === 'rigips' ? '#055cb1' : '#1A786E',
        light:
          process.env.REACT_APP_ENV === 'rigips'
            ? 'rgba(3, 104, 197, 0.2)'
            : 'rgba(153, 153, 0, 0.2)',
      },
      blue: '#0368C5',
      'blue-600': '#055cb1',
      red: '#E34A4A',
      'red-600': '#d64848',
      green: '#38b348',
      transparent: 'transparent',
      white: '#FFFFFF',
      'gray-100': '#F8F8F8',
      'gray-200': '#E5E5E5',
      'gray-300': '#D8D8D8',
      'gray-400': '#8E8E8E',
      black: '#565656',
    },
    spacing: {
      100: '100px',
      80: '80px',
      75: '75px',
      65: '65px',
      60: '60px',
      54.5: '54.5px',
      50: '50px',
      48: '48px',
      45: '45px',
      34.5: '34.5px',
      30: '30px',
      25: '25px',
      22: '22px',
      20: '20px',
      19.5: '19.5px',
      16.5: '16.5px',
      15.5: '15.5px',
      15: '15px',
      13: '13px',
      10: '10px',
      7: '7px',
      5: '5px',
      3: '3px',
      1: '1px',
      0: '0',
    },
    borderWidth: {
      0: '0',
      1: '1px',
    },
    boxShadow: {
      'shadow-md': '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    },
    width: {
      25: '25px',
      '1/12': '8.333333%',
      '2/12': '16.666667%',
      '3/12': '25%',
      '4/12': '33.333333%',
      '5/12': '41.666667%',
      '6/12': '50%',
      '7/12': '58.333333%',
      '8/12': '66.666667%',
      '9/12': '75%',
      '10/12': '83.333333%',
      '11/12': '91.666667%',
      '12/12': '100%',
      full: '100%',
      screen: '100vw',
    },
  },
  variants: [
    'responsive',
    'group-hover',
    'focus-within',
    'hover',
    'focus',
    'active',
    'first-child',
    'last-child',
  ],
  plugins: [
    function ({ addComponents, config }) {
      const buttons = {
        '.btn': {
          display: 'inline-block',
          color: config('theme.colors.black'),
          fontSize: config("theme.fontSize['10']"),
          fontWeight: config("theme.fontWeight['500']"),
          letterSpacing: config("theme.letterSpacing['1.5']"),
          padding: '20px 20px 19px 20px',
          textTransform: 'uppercase',
          borderWidth: config("theme.borderWidth.['1']"),
          borderColor: 'transparent',
          transition: 'all 0.1s linear',
        },
        '.btn-primary': {
          backgroundColor: config('theme.colors.brand.primary'),
          color: config('theme.colors.white'),
          '&:hover': {
            backgroundColor: config('theme.colors.brand.dark'),
          },
        },
        '.btn-secondary': {
          backgroundColor: 'transparent',
          color: config('theme.colors.brand.primary'),
          borderColor: config('theme.colors.brand.primary'),
          '&:hover': {
            color: config('theme.colors.white'),
            backgroundColor: config('theme.colors.brand.primary'),
          },
        },
        '.btn-tertiary': {
          backgroundColor: 'transparent',
          color: config('theme.colors.black'),
          borderColor: config('theme.colors.black'),
          '&:hover': {
            backgroundColor: config("theme.colors.['gray-200']"),
          },
        },
        '.btn-danger': {
          backgroundColor: config('theme.colors.red'),
          color: config('theme.colors.white'),
          '&:hover': {
            backgroundColor: config("theme.colors.['red-600']"),
          },
        },
        '.btn-secondary-danger': {
          backgroundColor: 'transparent',
          color: config('theme.colors.red'),
          borderColor: config('theme.colors.red'),
          '&:hover': {
            color: config('theme.colors.white'),
            backgroundColor: config('theme.colors.red'),
          },
        },
        '.btn-loading': {
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '56px',
        },
      }

      const typography = {
        '.section-heading': {
          color: config('theme.colors.black'),
          fontSize: config("theme.fontSize['20']"),
          fontWeight: config("theme.fontWeight['400']"),
          letterSpacing: config("theme.letterSpacing['0.23']"),
          borderBottom: `${config("theme.borderWidth['1']")} solid ${config(
            "theme.colors.['gray-200']",
          )}`,
          paddingBottom: config('theme.spacing.20'),
          marginBottom: config('theme.spacing.45'),
        },
        '.h1': {
          color: config('theme.colors.black'),
          fontSize: config("theme.fontSize['20']"),
          fontWeight: config("theme.fontWeight['400']"),
          letterSpacing: config("theme.letterSpacing['0.23']"),
        },
        '.label': {
          display: 'inline-block',
          marginBottom: config("theme.spacing['5']"),
          color: config('theme.colors.black'),
          fontSize: config("theme.fontSize['12']"),
          fontWeight: config("theme.fontWeight['400']"),
          letterSpacing: config("theme.letterSpacing['0.32']"),
        },
        '.link': {
          color: config('theme.colors.brand.primary'),
          fontSize: config("theme.fontSize['13']"),
          fontWeight: config("theme.fontWeight['400']"),
          letterSpacing: config("theme.letterSpacing['0.1']"),
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      }
      addComponents([buttons, typography])
    },
    function ({ addBase, config }) {
      addBase({
        body: {
          minWidth: '1024px',
          fontFamily: config('theme.fontFamily.sans'),
        },
        '.App': {
          display: 'flex',
          minHeight: '100vh',
          flexDirection: 'column',
        },
        // Allows to add .no-arrows class to hide number input arows
        'input[type=number].no-arrows::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0,
        },
        // Allows to add .no-arrows class to hide number input arows on moz
        'input[type=number].no-arrows': {
          '-moz-appearance': 'textfield',
        },
      })
    },
    function ({ addVariant, e }) {
      addVariant('first-child', ({ modifySelectors, separator }) => {
        modifySelectors(({ className }) => {
          return `.${e(`first-child${separator}${className}`)}:first-child`
        })
      })
    },
    function ({ addVariant, e }) {
      addVariant('last-child', ({ modifySelectors, separator }) => {
        modifySelectors(({ className }) => {
          return `.${e(`last-child${separator}${className}`)}:last-child`
        })
      })
    },
  ],
}
